import { Component, Input, OnInit } from '@angular/core';
import { BaseAppMComponent } from '../../base-components/base-app-m.component';
import { GlobalsService } from '../../services/globals.service';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';

import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DQOIReferenceData } from '../../models/DQOIReferenceData';
import { BaseDQOIComponent } from '../../base-components/base-dqoi.component';
import { AppClaims } from '../../models/AppClaims';
import { InventoryService } from '../../services/inventory.service';
import { CRUDActions } from '../../enums/CRUDActions';
import { InventoryCategoryBus } from '../../models/InventoryCategoryBus';
import { CommonFunctions } from '../../static/common-functions';
import { CPDialogResult } from '../../enums/CPDialogResult';
import { ConfirmOutput } from '../../models/ConfirmOutput';
import { BaseMessageInfo } from '../../models/BaseMessageInfo';
import { CommonValues } from '../../static/CommonValues';

@Component({
    selector: 'part-category-dialog',
    templateUrl: './part-category-dialog.component.html',
    styleUrls: ['./part-category-dialog.component.scss']
})
export class PartCategoryDialogComponent
    extends BaseAppMComponent<InventoryCategoryBus, InventoryService, null, null> implements OnInit {

    appCode: string = null;
    constructor(
        globals: GlobalsService,
        featureFlagService: FeatureFlagService,
        public svc_data: InventoryService,
        qry_rd: DQOIReferenceDataQuery,

    ) {
        super(globals, featureFlagService, qry_rd);

        this.appCode = "Part Category";
    }

    public editForm: UntypedFormGroup;

    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }

    saving: boolean = false;
    active: boolean = false;
    data: any;
    isCategorySelected: boolean = false;
    isNewCategory: boolean = false;
    isSaveReady: boolean = false;
    inventoryCategoryData: InventoryCategoryBus[] = [];
    action1: CRUDActions;

    @Input() title: string;
    @Input() message: string;

    public show(id?: any) {
        this.createForm();
        this.active = true;
        this.isCategorySelected = false;
        this.isNewCategory = false;
        this.isSaveReady = false;

        this.svc_data.getInventoryCategories().subscribe(data => {
            this.inventoryCategoryData = data.resultList;
        });
    }

    createForm() {
        this.editForm = new UntypedFormGroup({
            'inventoryCategoryId': new UntypedFormControl(),
            'inventoryCategoryName': new UntypedFormControl(null, Validators.required),
            'isActive': new UntypedFormControl(),
        });
    }

    public inventoryCategorySelected(selectedValue: any): void {
        if (selectedValue) {
            let dataObject: InventoryCategoryBus = this.inventoryCategoryData.find(x => x.inventoryCategoryId === selectedValue.inventoryCategoryId);
            this.setCategoryFormData(dataObject);
            this.isCategorySelected = true;
            this.isSaveReady = true;
            this.isNewCategory = true;
        }
        else {
            this.clear();
            this.isCategorySelected = false;
            this.isSaveReady = false;
            this.isNewCategory = false;
        }
    }

    public setCategoryFormData(formData: InventoryCategoryBus) {
        if (CommonFunctions.hasValue(formData)) {
            this.editForm.patchValue({
                inventoryCategoryId: formData.inventoryCategoryId,
                inventoryCategoryName: formData.inventoryCategoryName,
                isActive: formData.isActive,
            });
        }
        else {
            console.log("No data to map")
        }
    }

    ok() {
        this.trySave();
    }

    new() {
        this.isCategorySelected = true;
        this.isNewCategory = true;
        this.isSaveReady = true;
        this.editForm.patchValue({
            isActive: true,
        });
    }

    trySave() {
        let inventoryCategoryId = this.editForm.value.inventoryCategoryId;
        let inventoryCategoryName: any = this.editForm.value.inventoryCategoryName;
        let isCategoryActive = this.editForm.get("isActive").value;

        let doesInventoryCategoryExist: any = this.inventoryCategoryData.find(s => s.inventoryCategoryName === inventoryCategoryName && inventoryCategoryId != s.inventoryCategoryId);

        if (doesInventoryCategoryExist) {
            this.cnfShow("The inventory category already exists.", CRUDActions.None, null, "Duplicate Inventory Category", "DUP_inventoryCategoryName", false);

        }
        else {
            this.save();
        }

    }

    confirmCustom(data: ConfirmOutput) {
        if (data.dialogResult === CPDialogResult.ok && data.code === "EDIT_EXISTING") {
            this.save();
        }
    }

    save() {
        if (this.isSaveReady) {
            let user = this.globals.user;
            let inventoryCategoryName: any = this.editForm.value.inventoryCategoryName;
            let isPartActive = this.editForm.get("isActive").value;
            var exists = this.inventoryCategoryData.find(s => s.isActive && s.inventoryCategoryName.toLowerCase() === this.editForm.get("inventoryCategoryName").value.toLowerCase().trim()) && isPartActive;

            let busObj: InventoryCategoryBus = new InventoryCategoryBus();

            busObj.setFromForm(this.editForm.value);
            busObj.companyId = this.globals.companyId;
            busObj.setCommon(user.userid, new Date(Date.now()));
            busObj.setBeforeSave();

            if (!busObj.inventoryCategoryId) { busObj.inventoryCategoryId = CommonValues.Guid_Empty }

            this.svc_data.saveInventoryCategory(busObj).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.svc_data.getInventoryCategories().subscribe(data => {
                        this.inventoryCategoryData = data.resultList;
                    });
                    this.saveSuccess();
                    this.clear();
                    this.isCategorySelected = false;
                    this.isSaveReady = false;
                    this.isNewCategory = false;
                }
                else {
                    this.saveError(info.message);
                }

            },
                err => { this.CallFailed(err) }
            );
        }
    }

    CallFailed(err) {
        this.saveError(err)
    }

    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action1 = CRUDActions.None;
    }

    cancel() {

        if (this.isNewCategory) {

            this.clear();
            this.isCategorySelected = false;
            this.isSaveReady = false;
            this.isNewCategory = false;
        } else {
            this.hide();
        }

    }

    close() {
        this.hide();
    }
}
